export default __webpack_public_path__ + "static/media/Ballroll_00188.1235fb81.png";